import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { useBrand } from "context/BrandContext";
import { useNavProfile } from "hooks/useNavProfile";
import { useUiStatus } from "state/reactive-vars/ui-status-var";
import routeNames from "constants/route-names";

// Top bar of the small screens. It holds the button that opens the side navigation.
const MobileHeader = () => {
	const { theme } = useBrand();
	const { navProfile } = useNavProfile();
	const { uiStatusValue, updateUiStatus } = useUiStatus();
	const { pathname } = useLocation();
	const isOllieBrand = navProfile.sidebarBrand === "ollie";
	const showDashboardLink = pathname.startsWith(routeNames.OLLIE) && pathname !== routeNames.OLLIE_DASHBOARD;

	return (
		<header className="mobile-header">
			<div className="mobile-header-content">
				<button
					type="button"
					className="mobile-header-menu-button"
					onClick={() => updateUiStatus({ loggedSidebarCollapsed: !uiStatusValue.loggedSidebarCollapsed })}
					aria-label="Open side navigation"
				>
					<img src={`${process.env.PUBLIC_URL}/assets/images/icons/hamburger-menu.svg`} alt="" />
				</button>
				{isOllieBrand ? (
					<Link to={navProfile.homeRoute} className="mobile-header-brand">
						<img src={`${process.env.PUBLIC_URL}/assets/images/icons/ollie-owl.svg`} className="mobile-header-owl" alt="" />
						<span className="mobile-header-wordmark">Ollie.</span>
					</Link>
				) : (
					<Link to={navProfile.homeRoute} className="mobile-header-brand">
						<img src={`${process.env.PUBLIC_URL}${theme.navbarImage}`} className="mobile-header-logo" alt="Logo" />
					</Link>
				)}
				{showDashboardLink && (
					<Link to={routeNames.OLLIE_DASHBOARD} className="mobile-header-dashboard-link">
						<ArrowLeft size={16} />
						Dashboard
					</Link>
				)}
			</div>
		</header>
	);
};

export default MobileHeader;
